import { useEffect, useRef } from 'react';
import { useRouter } from 'next/router';

const getPathname = (path: string): string => path.split('?')[0] ?? path;

export const useScrollToTopOnLoad = (
  behavior: ScrollBehavior = 'smooth',
  left = 0,
  top = 0
): null => {
  const router = useRouter();
  const prevPathname = useRef<string>('');

  useEffect(() => {
    const handleRouteChangeComplete = (path: string) => {
      const pathname = getPathname(path);
      const isNewPathname = Boolean(
        prevPathname.current && pathname !== prevPathname.current
      );

      if (isNewPathname) {
        window.scrollTo({ top, left, behavior });
      }

      prevPathname.current = pathname;
    };

    router.events.on('routeChangeComplete', handleRouteChangeComplete);

    return () => {
      router.events.off('routeChangeComplete', handleRouteChangeComplete);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [behavior, left, top]);

  return null;
};
